"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
// converts an elements attributes to a plain array
var prefix = 'data-';
var isDataAttr = function (attr) { return attr.name.substr(0, prefix.length) === prefix; };
var attrsToArray = function (attrs) { return [].map.call(attrs, function (attr) { return attr; }); };
var camelCaseName = function (name) { return name.replace(/-(.)/g, function ($0, $1) { return $1.toUpperCase(); }); };
var isPlainObject = function (value) { return value && String(value) === '[object Object]'; };
/*
 * Converts an elements "data attributes" into a plain object
 * with keys in camel case format
 */
exports.datasetToObject = function (element) {
    var attrs = attrsToArray(element.attributes);
    var dataAttrs = attrs.filter(isDataAttr);
    return dataAttrs.reduce(function (obj, _a) {
        var _b;
        var name = _a.name, value = _a.value;
        return (__assign(__assign({}, obj), (_b = {}, _b[camelCaseName(name.substr(prefix.length))] = value, _b)));
    }, {});
};
/*
 * Converts deeply nested booleans to strings.
 * Mixpanel omits false values from event metadata, this ensures they display
 */
exports.boolsToStr = function (value) {
    if (Array.isArray(value)) {
        return value.map(function (v) { return exports.boolsToStr(v); });
    }
    if (isPlainObject(value)) {
        return Object.keys(value).reduce(function (clone, key) {
            clone[key] = exports.boolsToStr(value[key]);
            return clone;
        }, {});
    }
    if (typeof value === 'boolean')
        return String(value);
    return value;
};
